export default __webpack_public_path__ + "static/media/profile.7aa7d936.jpg";